export const View = ({ children, ...rest }) => {
  return <div {...rest}>{children}</div>;
};
